// src/pages/InstallGuide.js

import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaAndroid, FaApple } from 'react-icons/fa';
import ChocolateBrownSpinner from '../components/ChocolateBrownSpinner';

const InstallGuide = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const hasSeenGuide = localStorage.getItem('installGuideSeen');

    const isIOSStandalone = window.navigator.standalone === true;
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches || isIOSStandalone;

    // تشخیص موبایل بر اساس UserAgent و عرض صفحه
    const isMobileDevice = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) && window.innerWidth < 768;

    // ۱. اگر دستگاه دسکتاپ یا تبلت است -> بدون نمایش راهنما برود به وب‌سایت اصلی
    if (!isMobileDevice) {
      navigate('/home', { replace: true });
      return;
    }
    // ۲. اگر کاربر موبایل قبلاً راهنما را دیده یا PWA را نصب کرده -> هدایت به /home
    if (hasSeenGuide || isStandalone) {
      localStorage.setItem('installGuideSeen', 'true'); 
      navigate('/home', { replace: true });
    } else {
      // ۳. کاربر موبایل است و هنوز راهنما را ندیده -> نمایش راهنمای نصب
      setIsLoading(false);
    }
  }, [navigate]);

  

  useEffect(() => {
    const handleInstalled = () => {
      console.log('اپلیکیشن نصب شد');
      localStorage.setItem('installGuideSeen', 'true');
    };
  
    window.addEventListener('appinstalled', handleInstalled);
  
    return () => {
      window.removeEventListener('appinstalled', handleInstalled);
    };
  }, []);

  
  const handleContinue = () => {
    navigate('/home'); // مسیر اصلی اپلیکیشن
  };

  if (isLoading) {
    // می‌تونید اینجا لودینگ یا null برگردونید (نمایش چیزی نده)
    return   <div className="flex justify-center items-center min-h-screen bg-yellow-50">
      <ChocolateBrownSpinner />
    </div>
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-yellow-50 to-yellow-950 flex flex-col items-center justify-center text-right p-6 font-IranSans">
      <h1 className="text-3xl font-bold text-brown-700 mb-4">نصب اپلیکیشن کافی</h1>
      <p className="text-gray-700 mb-6 max-w-lg leading-loose">
        برای دسترسی سریع‌تر به اپلیکیشن کافی، می‌توانید آن را روی گوشی خود نصب کنید. مراحل زیر را دنبال کنید:
      </p>

      <div className="bg-yellow-50 shadow-md rounded-xl p-4 w-full max-w-md mb-6">
      <div className="flex items-center gap-2 text-brown-600 mb-2">
          <FaAndroid className="text-green-600 text-xl" />
          <h2 className="font-semibold text-lg">روی اندروید:</h2>
        </div>
        <ul className="list-disc pr-5 text-gray-600 space-y-2 text-sm leading-6">
          <li>روی آیکون سه نقطه در بالا یا پایین مرورگر کروم کلیک کنید.</li>
          <li>گزینه <strong>"Add to Home screen"</strong> یا <strong>"افزودن به صفحه اصلی"</strong> را انتخاب کنید.</li>
          <li>سپس گزینه "نصب" را بزنید.</li>
        </ul>
      </div>

      <div className="bg-yellow-50 shadow-md rounded-xl p-4 w-full max-w-md mb-6">
      <div className="flex items-center gap-2 text-brown-600 mb-2">
          <FaApple className="text-gray-700 text-xl" />
          <h2 className="font-semibold text-lg">روی آیفون (iOS):</h2>
        </div>
        <ul className="list-disc pr-5 text-gray-600 space-y-2 text-sm leading-6">
          <li>در مرورگر Safari وارد سایت شوید.</li>
          <li>روی آیکون اشتراک‌گذاری در پایین صفحه کلیک کنید (علامت مربع با فلش).</li>
          <li>گزینه <strong>"Add to Home Screen"</strong> را انتخاب کرده و سپس "افزودن" را بزنید.</li>
        </ul>
      </div>

      <button
        onClick={handleContinue}
        className="bg-brown-600 text-white py-2 px-6 rounded-full shadow hover:text-brown-700 transition-all"
      >
        ورود به اپلیکیشن
      </button>
    </div>
  );
};

export default InstallGuide;
